export enum RootTypeEnum {
	LADLE = 2,
	TUNDISH = 3,
}
